export default {
  props: ['ok', 'ko', 'popup'],
  data () {
    return {
      positionRandom: this.ko ? Math.round(Math.random()) : 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/question/okko/okko.js